export const FETCH_INTERNSHIP_REQUEST = 'FETCH_INTERNSHIP_REQUEST'
export const FETCH_INTERNSHIP_SUCCES = 'FETCH_INTERNSHIP_SUCCES'
export const FETCH_INTERNSHIP_ERROR = 'FETCH_INTERNSHIP_ERROR'


// WEBPACK FOOTER //
// ./src/constants/Internship.js